import React from 'react';

const Pagination = ({ currentPage, totalPages, handlePageChange }) => (
  <div className="pagination-container">
    <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>
      &laquo;
    </button>
    {Array.from({ length: totalPages }, (_, index) => (
      <button
        key={index}
        onClick={() => handlePageChange(index + 1)}
        className={currentPage === index + 1 ? "active" : ""}
      >
        {index + 1}
      </button>
    ))}
    <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>
      &raquo;
    </button>
  </div>
);

export default Pagination;